import { TextField } from '@nike/eds'
import { CaretLeft, CaretRight } from '@nike/nike-design-system-icons'
import { useState } from 'react'
import { PageSize } from './PageSize'
import { Paging } from './paging-hook'
import { SimpleTable, SimpleTableProps } from './SimpleTable'

function FromTextInput({ paging }) {
  const [value, setValue] = useState('')
  return (
    <TextField
      placeholder="Go to from"
      label="Go to from"
      hideLabel={true}
      id="input-from"
      type="number"
      step={paging.size}
      min={0}
      style={{ display: 'inline' }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          paging.setFrom(parseInt(e.currentTarget.value))
        }
      }}
    />
  )
}

export function Footer({ paging, hasPrevious, hasNext }) {
  const [goToFromShown, showGoToFrom] = useState(false)

  function iconColor(enabled: boolean) {
    return enabled ? 'gray' : 'var(--eds-color-text-link-disable)'
  }

  const footerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 16px 0 24px',
  }

  function onFooterClick(event: React.MouseEvent<HTMLElement>) {
    if (event.detail >= 8) {
      showGoToFrom(true)
    }
  }

  const previous = () => paging.setFrom(Math.max(paging.from - paging.size, 0))
  const next = () => paging.setFrom(paging.from + paging.size)

  return (
    <div style={footerStyle} onClick={onFooterClick}>
      <PageSize currentSize={paging.size} changeSize={paging.changeSize} />
      {goToFromShown && <FromTextInput paging={paging} />}
      <div>
        <CaretLeft
          onClick={() => hasPrevious && previous()}
          size="l"
          style={{ cursor: 'pointer' }}
          color={iconColor(hasPrevious)}
        />
        <CaretRight
          onClick={() => hasNext && next()}
          size="l"
          style={{ cursor: 'pointer' }}
          color={iconColor(hasNext)}
        />
      </div>
    </div>
  )
}

interface PaginatedTableProps extends Omit<SimpleTableProps, 'footer'> {
  paging: Paging
}

export function PaginatedTable(props: PaginatedTableProps) {
  const { paging, data } = props
  const hasNext = data?.length === paging.size
  const hasPrevious = paging.from > 0
  const renderFooter = hasPrevious || hasNext || data?.length > 10

  // Render the UI for your table
  return (
    <SimpleTable
      {...props}
      footer={
        renderFooter && (
          <tr>
            <td colSpan={999}>
              <Footer paging={paging} hasPrevious={hasPrevious} hasNext={hasNext} />
            </td>
          </tr>
        )
      }
    />
  )
}
